export const PURCHASE_POST_REQUEST = 'PURCHASE_POST_REQUEST'
export const PURCHASE_POST_SUCCESS = 'PURCHASE_POST_SUCCESS'
export const PURCHASE_POST_FAIL = 'PURCHASE_POST_FAIL'

export const PURCHASE_LIST_REQUEST = 'PURCHASE_LIST_REQUEST'
export const PURCHASE_LIST_SUCCESS = 'PURCHASE_LIST_SUCCESS'
export const PURCHASE_LIST_FAIL = 'PURCHASE_LIST_FAIL'

export const PURCHASE_UPDATE_REQUEST = 'PURCHASE_UPDATE_REQUEST'
export const PURCHASE_UPDATE_SUCCESS = 'PURCHASE_UPDATE_SUCCESS'
export const PURCHASE_UPDATE_FAIL = 'PURCHASE_UPDATE_FAIL'

export const ITEM_GET_REQUEST = 'ITEM_GET_REQUEST'
export const ITEM_GET_SUCCESS = 'ITEM_GET_SUCCESS'
export const ITEM_GET_FAIL = 'IMTE_GET_FAIL'

export const ITEM_UPDATE_REQUEST = 'ITEM_UPDATE_REQUEST'
export const ITEM_UPDATE_SUCCESS = 'ITEM_UPDATE_SUCCESS'
export const ITEM_UPDATE_FAIL = 'ITEM_UPDATE_FAIL'

export const TOKEN_CREATE_REQUEST = 'TOKEN_CREATE_REQUEST'
export const TOKEN_CREATE_SUCCESS = 'TOKEN_CREATE_SUCCESS'
export const TOKEN_CREATE_FAIL = 'TOKEN_CREATE_FAIL'

export const TOKEN_AUTHORIZATION_REQUEST = 'TOKEN_AUTHORIZATION_REQUEST'
export const TOKEN_AUTHORIZATION_SUCCESS = 'TOKEN_AUTHORIZATION_SUCCESS'
export const TOKEN_AUTHORIZATION_FAIL = 'TOKEN_AUTHORIZATION_FAIL'